class City {
  constructor(city) {
    this.type = 'city'
    Object.assign(this, {
      ...city,
      type: 'city',
    })
  }

  get searchOptionFormat() {
    return {
      type: this.type,
      value: this.code,
      label:
        this.airports.length > 1
          ? 'Tous les aéroports'
          : `${this.name}, ${this.country?.name || ''}`,
      subLabel:
        this.airports.length > 1
          ? `${this.name}, ${this.country?.name || ''}`
          : this.airports?.[0]?.name || this.name,
      selected: `${this.name} (${this.code})`,
      name: this.name,
    }
  }
}

export default City
